<template>
    <div>
        <icon-circled
            v-if="icon"
            :size="110"
            :icon="icon"
            :class="$css($theme.textPrimary)"
            class="d-block mx-auto mb-4"
        />

        <p
            v-if="title"
            class="font--20 lh--26 font-weight-light text-center mb-8"
            :class="$css($theme.textPrimary)"
        >
            {{ ucfirst(title) }}
        </p>

        <p
            v-if="description"
            class="font--14 text-dark text-center mb-0 text--ucfirst"
            v-html="description"
        />

        <div class="d-flex justify-content-between text-center mt-24">
            <base-button
                theme="secondary"
                class="mlsp-16 mnw-0 w-50"
                data-t="cancel-button"
                @click="cancel"
            >
                {{ cancelText }}
            </base-button>

            <base-button
                class="mlsp-16 mnw-0 w-50"
                data-t="button-confirm"
                @click="accept"
            >
                {{ confirmText }}
            </base-button>
        </div>
    </div>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import BaseButton from "~/components/buttons/BaseButton"
import IconCircled from "~/components/elements/IconCircled"

export default {
    props: {
        title: String,
        description: String,
        icon: {
            type: String,
            default: "info",
        },

        options: {
            type: Object,
            default: () => {
                return {}
            },

            required: false,
        },
    },

    emits: ["done"],

    computed: {
        cancelText() {
            if (this.options.cancelText) {
                return this.options.cancelText
            }
            return this.$t("common.cancel")
        },

        confirmText() {
            if (this.options.confirmText) {
                return this.options.confirmText
            }
            return this.$t("common.confirm")
        },
    },

    methods: {
        accept() {
            this.$emit("done", true)
        },

        cancel() {
            this.$emit("done", false)
        },

        ucfirst,
    },

    components: {
        BaseButton,
        IconCircled,
    },
}
</script>
